import { faChevronDown, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { usePopupDispatch } from '../Popup/PopupProvider';

const Container = styled.div`
  position: relative;
  &:focus {
    outline: none;
  }
`;

const CurrentOption = styled.div`
  border: 1px solid #eaeaf2;
  border-radius: 6px;
  padding: 14px 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
  &:focus {
    box-shadow: 0px 3px 14px #00000014;
    outline: none;
  }
`;

const AccountName = styled.div`
  font-weight: 500;
  font-size: 14px;
`;

const DropdownIcon = styled.div`
  color: #9395c2;
`;

const DropdownOptions = styled.div`
  position: absolute;
  top: 60px;
  width: 100%;
  left: 0px;
  background: white;
  padding: 7px 6px;
  border-radius: 6px;
  box-shadow: 0px 3px 18px #00000014;
  z-index: 10;
`;

const Option = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s all;
  &:hover {
    background: #f7f7f9;
  }
`;

const OptionName = styled.div`
  font-weight: 500;
  font-size: 14px;
`;

const OptionMessage = styled.div`
  font-weight: 500;
  font-size: 14px;
`;

const RightItems = styled.div`
  display: flex;
  align-items: center;
`;

const CardNum = styled.div`
  margin-right: 22px;
  font-size: 13px;
  display: flex;
  color: #9395c2;
`;

const CardIcon = styled.div`
  color: #9395c2;
  margin-right: 14px;
`;

const AddMethod = styled.div`
  margin-right: 22px;
  font-size: 13px;
  color: #ffffff;
  background: #5d6ef8;
  padding: 7px 26px;
  border-radius: 4px;
`;

export type DropOption = {
  id: string;
  accountName: string;
  paymentMethod?: {
    last4: string;
  };
  issueMessage?: string;
  currency: string;
};

type Props = {
  onChange: (val: DropOption) => void;
  selected: DropOption;
  options: DropOption[];
};

function SubscribeAccountSelector({ options, selected, onChange }: Props) {
  const [dropped, setDropped] = useState(false);
  const popupDispatch = usePopupDispatch();

  const containerRef: any = useRef(null);

  const addPaymentMethod = (e: any) => {
    e?.stopPropagation();
    popupDispatch({
      action: 'open',
      popupType: 'update-subscriber-card',
      onClose: () => {
        window.location.reload();
      },
    });
  };
  return (
    <Container
      onFocus={() => setDropped(true)}
      onBlur={() => setDropped(false)}
      ref={containerRef}
      tabIndex={0}
    >
      <CurrentOption>
        <AccountName>{selected.accountName}</AccountName>
        <RightItems>
          {selected.paymentMethod && (
            <CardNum>
              <CardIcon>
                <FontAwesomeIcon icon={faCreditCard} />
              </CardIcon>{' '}
              •••• •••• •••• {selected.paymentMethod.last4}
            </CardNum>
          )}
          {!selected.paymentMethod && (
            <AddMethod onClick={addPaymentMethod}>Add payment method</AddMethod>
          )}
          <DropdownIcon>
            <FontAwesomeIcon icon={faChevronDown} />
          </DropdownIcon>
        </RightItems>
      </CurrentOption>
      {dropped && (
        <DropdownOptions>
          {options.map((option) => (
            <Option
              onClick={() => {
                onChange(option);
                if (containerRef.current) containerRef.current.blur();
              }}
            >
              <OptionName>{option.accountName}</OptionName>
              <OptionMessage>{option.issueMessage}</OptionMessage>
            </Option>
          ))}
        </DropdownOptions>
      )}
    </Container>
  );
}

export default SubscribeAccountSelector;
